export const DEFAULT_SITE_URL = 'https://www.farisrehman.co.uk';
export const PORTFOLIO_METADATA: Record<string, { title: string; description: string }> = {
    '/Portfolio/index.html': {
        title: 'Faris Rehman — Software Engineer',
        description: 'Explore Faris Rehman’s software engineering work, open source projects, and experience.',
    },
    '/Portfolio/about.html': {
        title: 'About — Faris Rehman',
        description: 'Learn about Faris Rehman’s software engineering experience, technical skills, and achievements.',
    },
    '/Portfolio/projects.html': {
        title: 'Projects — Faris Rehman',
        description: 'Explore Faris Rehman’s projects in systems programming, Java, and web development.',
    },
    '/Portfolio/contact.html': {
        title: 'Contact — Faris Rehman',
        description: 'Contact Faris Rehman about software engineering projects and opportunities.',
    },
};
const GAME_TITLES: Record<string, string> = {
    'snake-game': 'Snake',
    'tic-tac-toe': 'Tic Tac Toe',
    'memory-game': 'Memory',
    'breakout-game': 'Breakout',
    'word-scramble': 'Word Scramble',
};
export function pageTitle(path: string, fallback?: string): string {
    if (path === '/') return PORTFOLIO_METADATA['/Portfolio/index.html'].title;
    if (path === '/contact.html') return PORTFOLIO_METADATA['/Portfolio/contact.html'].title;
    if (PORTFOLIO_METADATA[path]) return PORTFOLIO_METADATA[path].title;
    if (path === '/Games') return 'Games — Faris Rehman';
    const game = path.match(/^\/Games\/([^/]+)\.html$/)?.[1];
    return `${(game && GAME_TITLES[game]) || fallback || 'Portfolio'} — Faris Rehman`;
}
